import { Link, useLocation } from "react-router-dom";
import vosslohLogo from '../img/vossloh-logo.svg';
import UserProfileDisplay from './UserProfileDisplay';
import { useOktaAuth } from '@okta/okta-react';
import LoginButton from "./LoginButton";
import { TabData } from "./InterfaceInfo";
import { useUserInfoSchema } from "../state/services";
import { useState } from "react";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
// Parse the environment variable 
const tabData: TabData = JSON.parse(process.env.REACT_APP_TAB || '{}');

function AppBar() {
    const { authState } = useOktaAuth();
    const isAuthenticated = authState?.isAuthenticated;
    const userInfo = useUserInfoSchema()

    const [menuOpen, setMenuOpen] = useState(false);

return (
    <header className="fixed top-0 left-0 right-0 z-20 border-b border-gray-200 bg-white shadow-sm">
        <div className="flex h-14 items-center justify-between px-4">
            {/* LEFT SIDE */}
            <div className="flex min-w-0 flex-1 items-center gap-8">
                <img
                    src={vosslohLogo}
                    alt="vossloh-logo"
                    className="block h-8 w-auto md:h-9"
                />

                <h1 className=" text-base font-bold leading-none text-gray-700 sm:block md:text-2xl">
                    {tabData.application}
                </h1>

                <nav className="hidden h-full lg:flex items-center gap-2 text-base font-bold">
                    <RouteLink destination="/" text="Map" />

                    {userInfo?.user_group === "admin" && (
                        <RouteLink destination="/admin" text="Dashboard" />
                    )}
                    <RouteLink destination="/about" text="About Us" />
                    <RouteLink destination="/help" text="Help & FAQ" />

                    {tabData.number_of_menus > 0 &&
                        tabData.details_of_menus.map((menu, index) => (
                            <RouteLink key={index} destination={menu.path} text={menu.name} />
                        ))}
                </nav>
            </div>

            {/* RIGHT SIDE */}
            <div className="flex items-center gap-2">
                <div className="hidden lg:flex h-full items-center">
                    {isAuthenticated ? <UserProfileDisplay /> : <LoginButton />}
                </div>

                <button
                    type="button"
                    className="rounded-md p-2 text-gray-700 hover:bg-gray-100 lg:hidden"
                    onClick={() => setMenuOpen((prev) => !prev)}
                >
                    {menuOpen ? <CloseIcon /> : <MenuIcon />}
                </button>
            </div>
        </div>

        {menuOpen && (
            <div className="border-t bg-white px-4 py-3 lg:hidden">
                <nav className="flex flex-col gap-2">
                    <RouteLink destination="/" text="Map" onClick={() => setMenuOpen(false)} />

                    {userInfo?.user_group === "admin" && (
                        <RouteLink
                            destination="/admin"
                            text="Dashboard"
                            onClick={() => setMenuOpen(false)}
                        />
                    )}

                    <RouteLink destination="/about" text="About Us" onClick={() => setMenuOpen(false)} />

                    {tabData.number_of_menus > 0 &&
                        tabData.details_of_menus.map((menu, index) => (
                            <RouteLink
                                key={index}
                                destination={menu.path}
                                text={menu.name}
                                onClick={() => setMenuOpen(false)}
                            />
                        ))}

                    <div className="pt-2 lg:hidden">
                        {isAuthenticated ? <UserProfileDisplay /> : <LoginButton />}
                    </div>
                </nav>
            </div>
        )}
    </header>
);
}

function RouteLink({ destination, text, onClick }: { destination: string; text: string, onClick?: () => void }) {
    const route = useLocation();

    const isActive = route.pathname === destination;

    return (
        <Link
            to={destination}
            onClick={onClick}
            className={`ts-app-bar-link ${isActive ? "ts-app-bar-link-active" : ""}`}
        >
            {text}
        </Link>
    );
}

export default AppBar;